import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { providerSlugZodSchema } from "@@/shared/providers/provider";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import {
    QuoteEventIdFactory,
    quoteEventIdZodSchema,
} from "@@/shared/quotes/quote-events/_quote-event-id";
import {
    quoteSignatureFactory,
    type QuoteEventSignature,
} from "@@/shared/quotes/quote-events/signature-factory";
import { quoteIdZodSchema } from "@@/shared/quotes/quote-id";
import type { Except } from "type-fest";
import { z } from "zod";

const _quoteEventBaseZodObject = z.object({
    _id: quoteEventIdZodSchema,
    _type: z.literal("QUOTE_EVENT"),
    _createdAt: isoAndUnixZodSchema,
    _version: z.number().min(0),

    signature: z.string() as unknown as z.ZodType<QuoteEventSignature>,

    quoteId: quoteIdZodSchema,
    providerId: providerIdZodSchema,
    providerSlug: providerSlugZodSchema,
});
type _QuoteEventBase = z.infer<typeof _quoteEventBaseZodObject>;
const _QuoteEventBaseZodSchema: z.ZodSchema<_QuoteEventBase> =
    _quoteEventBaseZodObject;

type _quoteEventBaseFactoryParams = Except<
    _QuoteEventBase,
    "_id" | "_type" | "_createdAt" //| "signature"
>;
const _quoteEventBaseFactory = (
    params: Except<_quoteEventBaseFactoryParams, "signature"> & {
        signature:
            | QuoteEventSignature
            | Parameters<typeof quoteSignatureFactory>;
        _id?: _QuoteEventBase["_id"];
    },
): _QuoteEventBase => {
    const { signature, _id, ...rest } = params;
    return {
        _id: _id ?? QuoteEventIdFactory(),
        _createdAt: nowIsoAndUnix(),
        _type: "QUOTE_EVENT",
        signature: Array.isArray(signature)
            ? quoteSignatureFactory(...signature)
            : signature,
        ...rest,
    };
};

export {
    _quoteEventBaseFactory,
    _quoteEventBaseZodObject,
    _QuoteEventBaseZodSchema,
};
export type { _QuoteEventBase, _quoteEventBaseFactoryParams };
